const nodeTitle = document.querySelector('head title');

module.exports = (title) => {
  nodeTitle.innerHTML = 'Lunu Console &mdash; ' + title;
};
